var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { PaginationSerp } from "@/components/Pagination";
import { SerpJob, SerpJobs } from "@/components/cortex";
import { ClickTrackingPixel } from "../UserTracking";
import { SearchResultsListItem } from "./SearchResultsListItem";
export var SearchResultsListPanel = function (_a) {
    var searchData = _a.searchData, setIsRightPaneOpen = _a.setIsRightPaneOpen, selectedJobKey = _a.selectedJobKey, setSelectedJobKey = _a.setSelectedJobKey;
    var jobs = searchData.jobs, pageCursors = searchData.pageCursors;
    var _b = useState(_jsx(_Fragment, {})), trackingImage = _b[0], setTrackingImage = _b[1];
    var onClickJob = function (job) {
        var _a;
        if (job.clickTrackUrl) {
            // TODO also fetch on initial load of the job search results? We show the job already without an explicit click.
            var trackingPixel = _jsx(ClickTrackingPixel, { url: job.clickTrackUrl });
            setTrackingImage(trackingPixel);
        }
        setSelectedJobKey(job.jobKey);
        setIsRightPaneOpen(true);
        (_a = document.querySelector("aside")) === null || _a === void 0 ? void 0 : _a.focus({
            preventScroll: true,
        });
    };
    var SerpJobComponent = function (_a) {
        var job = _a.job, rest = __rest(_a, ["job"]);
        if (jobs.length === 0)
            return _jsx(_Fragment, {});
        var variant = job.jobKey === selectedJobKey ? "active" : "inactive";
        return (_jsx(SerpJob, __assign({ job: job }, rest, { variant: variant }, { children: _jsx(SearchResultsListItem, { job: job }) })));
    };
    var props = {
        jobs: jobs,
        onClickJob: onClickJob,
        SerpJobComponent: SerpJobComponent,
    };
    return (_jsxs(_Fragment, { children: [_jsx(SerpJobs, __assign({}, props)), _jsx(PaginationSerp, { pageCursors: pageCursors }), trackingImage] }));
};
